export default class User {
  id: number | null = null;
  email: string;
  jwtToken: string | null = null;
  limitSeconds: number = 7200;
  mcpToken: string | null = null;

  constructor(_props: any) {
    // alert(JSON.stringify(_props));
    this.id = _props.id !== undefined ? _props.id : null;
    this.email = _props.email;
    this.jwtToken = _props.jwtToken;
    if (_props.limit_seconds) {
      this.limitSeconds = _props.limit_seconds;
    } else {
      this.limitSeconds = 7200;
    }
    this.mcpToken = _props.mcp_token ? _props.mcp_token : null;
    // console.error(JSON.stringify(_props));
    // alert(JSON.stringify(_props));
    // alert(this.limitSeconds);
  }

}
